import React, { useState, useEffect } from "react";
import { TextInput, NumberInput, Select } from "../form/inputs";
import PrimaryBtn from "../button/PrimaryBtn";
import canada from "../../assets/images/svgs/country/canada.svg";
import india from "../../assets/images/svgs/country/india.svg";
import usa from "../../assets/images/svgs/country/usa.svg";
import { useDispatch, useSelector } from "react-redux";
import { getCountry } from "../../redux/thunks/registerThunks";
import { useParams } from "react-router-dom";
import {
  addNewCustomers,
  getCustomerDetailById,
} from "../../redux/thunks/addCustomerThunk";
import toast from "react-hot-toast";

const Editcustomer = ({ open, onClose, onUpdated, customerId }) => {
  const dispatch = useDispatch();
  const [countryCode, setCountryCode] = useState();
  const [contactNo, setContactNo] = useState("");
  const [customerName, setCustomerName] = useState("");
  const { countries: countryFromApi } = useSelector(
    (state) => state.setupProfile,
  );

  const { isCustomerLoading } = useSelector((state) => state.addCustomers);

  const COUNTRY_FLAGS = {
    99: india,
    38: canada,
    226: usa,
  };

  useEffect(() => {
    dispatch(getCountry());
  }, [dispatch]);

  const countries = countryFromApi?.map((cu) => {
    return {
      id: cu.id,
      value: cu.id,
      label: `+${cu.country_code}`,
      image: COUNTRY_FLAGS[cu.id] || null,
      min_phone_length: cu.min_phone_length,
      max_phone_length: cu.max_phone_length,
    };
  });

  useEffect(() => {
    if (countries.length && countryCode === undefined) {
      setCountryCode(countries[0].value);
    }
  }, [countries]);

  const selectedCountry = countries.find((c) => c.value === countryCode);

  useEffect(() => {
    if (open) {
      // Fetch customer details again whenever modal opens
      const payload = { customer_id: customerId };
      dispatch(getCustomerDetailById(payload))
        .unwrap()
        .then((res) => {
          const customersName = res.data?.customer_name;
          const customerConc = res.data?.contact_no;
          const countryId = res.data?.country_id;
          setCountryCode(countryId);
          setCustomerName(customersName);
          setContactNo(customerConc);
        });
    } else {
      setCustomerName("");
      setContactNo("");
    }
  }, [open, customerId, dispatch]);

  const handleUPdateCustomer = async () => {
    const payload = {
      customer_id: customerId,
      country_id: selectedCountry.id,
      contact_no: contactNo,
      customer_name: customerName,
    };
    // console.log("The customers payload is :", payload);
    try {
      const res = await dispatch(addNewCustomers(payload)).unwrap();
      if (res.success) {
        toast.success(res.message || "Customer Updated Successfully");
        onClose();
        if (typeof onUpdated === "function") {
          onUpdated(); // 🔥 safe call
        }
      } else {
        toast.error(res.message || "Update fails");
      }
    } catch (err) {
      toast.error(err?.message || err || "Something went wrong");
    }
  };

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/80" onClick={onClose} />

      {/* Modal */}
      <div className="relative w-full max-w-xl bg-gray-50 rounded-xl shadow-lg   z-50">
        {/* Header */}
        <div className="flex items-center h-14 bg-white px-4 shadow-sm">
          <h1 className="mx-auto text-lg font-semibold text-gray-900">
            Edit Customers
          </h1>

          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-gray-100"
          >
            X
          </button>
        </div>

        {/* Content */}
        <div className="p-4 space-y-6">
          <div>
            <TextInput
              label="Customer Name"
              placeholder="Enter Customer Name"
              value={customerName}
              onChange={(e) => setCustomerName(e.target.value)}
            />
          </div>
          <div>
            <label className="text-sm text-gray-600 mb-1 block">
              Contact Number
            </label>

            <div className="flex gap-3 mb-4">
              {/* Country Code */}
              <div className="w-32">
                <Select
                  value={countryCode}
                  onChange={(value) => setCountryCode(value)}
                  options={countries}
                  variant="withImages"
                />
              </div>

              {/* Mobile Number */}
              <div className="w-2/3">
                <NumberInput
                  placeholder="Enter mobile number"
                  value={contactNo}
                  onChange={(e) => setContactNo(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="flex justify-center">
            <PrimaryBtn
              isLoading={isCustomerLoading}
              btnName="Save"
              clickEvent={handleUPdateCustomer}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Editcustomer;
